// extracted by mini-css-extract-plugin
export default {"root":"fullscreenframe_root__QJtDr","tenant-logo":"fullscreenframe_tenant-logo__gRbLY","frame":"fullscreenframe_frame__UMHi+"};